import { DescriptionOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';
import dayjs from "dayjs";
import { DataGridPro } from '@mui/x-data-grid-pro';
import React, { useEffect, useState, useMemo } from 'react';
import { getAmountCell } from '../../utils/utils';
import LineItemDetailPanel from './lineItemDetailPanel';
import { CALCULATION_EDITABLE_FIELDS } from '../../constants/constant';

function LineItemsPanel(props) {
    const [rows, setRows] = useState([]);
    const [expandedRowIds, setExpandedRowIds] = useState([]);

    const { rows: rowsProp, lastExpandedRowId } = props;

    useEffect(() => {
        if (rowsProp && rowsProp.length > 0) {
            setRows(rowsProp);
            setExpandedRowIds(lastExpandedRowId ? [lastExpandedRowId] : []);
        }
    }, [rowsProp, lastExpandedRowId]);

    const handleExpandedRowIdChange = (newIds) => {
        const recordData = rows.find((row) => row.id === expandedRowIds[0]);

        if (expandedRowIds.length > 0 && recordData) {
            props.updateTotalInterest(recordData.id, recordData.calculatedInterest, recordData.assignmentNo, recordData.customerNo);
        }

        setExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds);
    };

    const columns = useMemo(() => [
        {
            field: 'docNoOfAccountingDocNo',
            width: 110,
            renderCell: (params) => `${params.row.docNoOfAccountingDocNo}`,
        },
        {
            field: 'documentType',
            width: 100,
            renderCell: (params) => <Chip icon={<DescriptionOutlined />} label={params.row.documentType} />,
        },
        {
            field: 'reasonCodeForPayment',
            width: 270,
            renderCell: (params) => `${params.row.reasonCodeForPayment}`,
        },
        {
            field: 'startDate',
            width: 150,
            renderCell: (params) => {
                const date = params.row.startDate;
                return date ? `SD : ${dayjs(date).format('DD-MM-YYYY')}` : '';
            },
        },
        {
            field: 'endDate',
            width: 150,
            renderCell: (params) => {
                const date = params.row.endDate
                return date ? `ED : ${dayjs(date).format('DD-MM-YYYY')}` : '';
            },
        },
        {
            field: 'amountInDocCurrency',
            width: 150,
            renderCell: (params) => {
                const amount = params.row.debitCreditIndicator === 'H' ? -params.row.amountInDocCurrency : params.row.amountInDocCurrency;
                return <div>{getAmountCell(amount, params.row.currencyKey)}</div>;
            },
        }
    ], []);

    const detailPanel = ({ row }) => {
        const reasonCodesRates = props.reasonCodes.filter((item) => item.customerNo === row.customerNo.substring(2));

        return (
            <LineItemDetailPanel
                row={row}
                view={props.view}
                updateTotalInterest={props.updateTotalInterest}
                editableFields={CALCULATION_EDITABLE_FIELDS}
                save={props.save}
                reasonCodeRateList={reasonCodesRates.length > 0 ? reasonCodesRates[0].reasonCodeRateList : []}
            />
        );
    };

    const getGridHeight = () => {
        const expandedRowHeight = 500;
        const rowHeight = 40;
        return expandedRowIds.length === 0
            ? (rows.length * rowHeight) + (rows.length * rowHeight + 30)
            : (rows.length * rowHeight + 30) + expandedRowHeight;
    };

    const gridHeight = getGridHeight();

    return (
        <div style={{ background: "#FFF" }}>
            <div style={{ marginInline: '30px', backgroundColor: "#FFF" }}>
                <DataGridPro
                    rows={rows}
                    columns={columns}
                    onExpandedRowIdsChange={handleExpandedRowIdChange}
                    expandedRowIds={expandedRowIds}
                    getDetailPanelContent={detailPanel}
                    getDetailPanelHeight={() => 'auto'}
                    detailPanelExpandedRowIds={expandedRowIds}
                    onDetailPanelExpandedRowIdsChange={handleExpandedRowIdChange}
                    sx={{
                        "& .MuiDataGrid-columnHeader": {
                            display: 'none',
                        },
                        "& .MuiDataGrid-cell": {
                            backgroundColor: "#fff",
                            justifyContent: "space-between"
                        },
                        "& .MuiDataGrid-row": {
                            backgroundColor: "#fff",
                            boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
                            margin: "3px",
                            padding: "2px",
                        },
                        "& .MuiDataGrid-filler": {
                            backgroundColor: "#fff",
                        },
                        borderRadius: "4px",
                        padding: "2px",
                        backgroundColor: "#fff",
                        marginBottom: "5px",
                        height: `${gridHeight}px`,
                    }}
                />
            </div>
        </div>
    );
}

export default LineItemsPanel;